//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      title: '不限',
      selected: {
        // key 表示父级索引 value 表示子级索引
        0: -1,
        1: -1,
        2: -1,
        3: -1,
      },
      turns: [{ value: true }, { value: true }, { value: true }, { value: true }]
    }
  },
  props: {
    conditions: {
      type: Array,
      default: [
        {
          name: '',
          list: []
        }
      ]
    },
    // 判断是否是多行单选， 默认为多行单选
    isSingleSelection: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    arrowTop () {
      return 'http://www.xcz.im/library/img/jianTop.png'
    },

    arrowBottom () {
      return 'http://www.xcz.im/library/img/jianBtn.png'
    }
  },

  methods: {
    handleClickItem (item, type) {
      this.$emit('handleClickItem', item, type)
    },

    handleClickUnlimit (type) {
      this.$emit('handleClickUnlimit', type)
    },

    setRed (indexParent, indexChild) {
      this.selected[indexParent] = indexChild

      if (this.isSingleSelection) {
        for (const key in this.selected) {
          if (key != indexParent) {
            this.selected[key] = -1
          }
        }
      }
    },

    changeTitle (text, indexParent) {
      if (this.isSingleSelection) {
        this.title = text
      } else {
        // 多选title的处理
        // title: 作者-分类-朝代-体裁
        let title = this.title.split('--')

        title[indexParent] = text

        if (title.every(mem => mem === text)) {
          title.length = 1
        }
        
        this.title = title.join('--')
      }
    },

    clickTurns (indexParent) {
      this.turns[indexParent].value = !this.turns[indexParent].value
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/nav_common/CommonList.vue